import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import RemainingCustomerPackageMain from "./component/RemainingCustomerPackageMain";

const title = "Remaining Packages";

const RemainingCustomerPackageMainPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <RemainingCustomerPackageMain />;
};

export default RemainingCustomerPackageMainPage;
